import React, { useState, useRef, useEffect } from 'react';

import { GoPlus } from 'react-icons/go';
import { Container, Image, Content, Title, Copy, Toggle } from './Collapse.style';


type CollapseProps = React.PropsWithChildren<{
  title: string,
  content: string,
  image: string,
}>;

export const Collapse = ({ title, content, image } : CollapseProps) => {
  const copy = useRef(null);
  const [show, setShow] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(copy.current.offsetHeight);

    const onResize = () => setHeight(copy.current.offsetHeight);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <Container>
      <Image src={image} alt={title} />
      <Content>
        <Title>{title}</Title>
        <Toggle show={show} onPress={() => setShow(!show)}><GoPlus /></Toggle>
        <Copy show={show} ht={height}>
          <p ref={copy}>{content}</p>
        </Copy>
      </Content>
    </Container>
  );
};


